import { useEffect, useState } from "react";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import { post } from "../js/post";
import { focusElement, selectedOptic, userData } from "../js/utils";
import WacomSignaturePopup from "./WacomSignaturePopup";

export function GDPRConsent({
  patientData,
  createPopupQuestion,
  removePopupQuestion,
  onClose,
}) {
  const [data, setData] = useState({
    nombreResponsable: "",
    dniResponsable: "",
    serviciosWhatsapp: true,
    serviciosSMS: true,
    serviciosEmail: true,
    serviciosTelefono: true,
    serviciosPostal: true,
    comercialWhatsapp: true,
    comercialSMS: true,
    comercialEmail: true,
    comercialTelefono: true,
    comercialPostal: true,
  });
  const [consent, setConsent] = useState("");
  const [logo, setLogo] = useState("");
  const [wacomPopup, setWacomPopup] = useState(false);

  const getConsent = async () => {
    const response = await post(
      "/support-extra/gestionDocumental/ObtenerTextoRGPD.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
      },
    );
    setConsent(response.texto);
  };

  const getLogo = async () => {
    const response = await post(
      "/support-extra/gestionDocumental/ObtenerLogoOptica.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
      },
    );
    setLogo(response.logo);
  };

  const generateConsent = async (signature) => {
    // console.log("USERDATA: ", userData);
    const response = await post(
      "/support-extra/gestionDocumental/GenerarDocumentoLOPD.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: patientData.id,
        agente: userData.nombre + " " + userData.apellidos,
        firma: signature,
        ...data,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idPaciente: patientData.id,
        // agente: userData.nombre + " " + userData.apellidos,
        // firma: signature,
        // ...data,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `RGPD_${patientData.name}.pdf`;
      a.click();
      createPopupQuestion(
        "Consentimiento GDPR generado satisfactoriamente.",
        () => {
          onClose();
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      nombreResponsable: patientData.name,
      dniResponsable: patientData.nif,
    }));
    getConsent();
    getLogo();
  }, [patientData]);

  useEffect(() => {
    focusElement(200);
  }, []);

  return (
    <div className="popup-container">
      {wacomPopup && (
        <WacomSignaturePopup
          onSave={async (signature) => {
            setWacomPopup(false);
            await generateConsent(signature);
          }}
          onClose={() => {
            setWacomPopup(false);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Consentimiento RGPD</span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className={`tab-content ap-content`}
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel">
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 300,
                    height: 200,
                    backgroundColor: "#f9f9f9",
                    borderRadius: 15,
                    padding: 10,
                  }}
                >
                  {logo && (
                    <img src={logo} alt="Logo" style={{ width: "100%" }} />
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                  }}
                >
                  <div
                    className="opt-table-tooltip grid-5"
                    id="gdpr-consent-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      DNI paciente
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={-1}
                        type="type-only-charnumbers"
                        size={0}
                        input={patientData.nif}
                        inactive={true}
                        onChange={() => {}}
                        onClick={() => {}}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      DNI responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={200}
                        type="type-only-charnumbers"
                        size={0}
                        maxLength={12}
                        input={data.dniResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            dniResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Paciente
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={-1}
                        type="type-only-charnumbers"
                        size={0}
                        input={patientData.name}
                        inactive={true}
                        onChange={() => {}}
                        onClick={() => {}}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={201}
                        type="type-alpha"
                        size={0}
                        input={data.nombreResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            nombreResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div className="opt-table-title" style={{ margin: 0 }}>
                      Servicios
                    </div>
                    <div
                      className="opt-table-tooltip grid-14"
                      id="gdpr-consents-grid"
                    >
                      <div className="cell cell-label cell-start-content">
                        WhatsApp
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={202}
                          active={data.serviciosWhatsapp}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              serviciosWhatsapp: !prev.serviciosWhatsapp,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        SMS
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={203}
                          active={data.serviciosSMS}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              serviciosSMS: !prev.serviciosSMS,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Postal
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={204}
                          active={data.serviciosPostal}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              serviciosPostal: !prev.serviciosPostal,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Email
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={205}
                          active={data.serviciosEmail}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              serviciosEmail: !prev.serviciosEmail,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Teléfono
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={206}
                          active={data.serviciosTelefono}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              serviciosTelefono: !prev.serviciosTelefono,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div className="opt-table-title" style={{ margin: 0 }}>
                      Comercial
                    </div>
                    <div
                      className="opt-table-tooltip grid-14"
                      id="gdpr-consents-grid-comercial"
                    >
                      <div className="cell cell-label cell-start-content">
                        WhatsApp
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={207}
                          active={data.comercialWhatsapp}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              comercialWhatsapp: !prev.comercialWhatsapp,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        SMS
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={208}
                          active={data.comercialSMS}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              comercialSMS: !prev.comercialSMS,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Postal
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={209}
                          active={data.comercialPostal}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              comercialPostal: !prev.comercialPostal,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Email
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={210}
                          active={data.comercialEmail}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              comercialEmail: !prev.comercialEmail,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Teléfono
                      </div>
                      <div className="cell">
                        <CheckBox
                          tabIndex={211}
                          active={data.comercialTelefono}
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              comercialTelefono: !prev.comercialTelefono,
                            }));
                          }}
                        ></CheckBox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="opt-table-title">Consentimiento</div>
                <div
                  style={{
                    display: "flex",
                    overflowY: "auto",
                    maxHeight: 300,
                    paddingRight: 20,
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: consent }} />
                </div>
              </div>
              <div
                className="popup-buttons"
                style={{ justifyContent: "center", gap: 20 }}
              >
                <ButtonIconH
                  text="Firmar"
                  small={true}
                  onClick={() => {
                    setWacomPopup(true);
                  }}
                ></ButtonIconH>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
